import React, { PureComponent } from 'react';
import './Cloud.css';

class Cloud extends PureComponent {
	render() {
		const { className } = this.props;
		return (
			<g className={`Cloud ${className}`}>
				<path className="fill" d="M20.114,12.036c-0.014,0-0.025,0.004-0.039,0.004c0.012-0.128,0.039-0.25,0.039-0.381
					c0-2.285-1.853-4.137-4.137-4.137c-1.648,0-3.061,0.971-3.725,2.366c-0.667-0.886-1.717-1.467-2.912-1.467
					c-1.899,0-3.441,1.453-3.621,3.305c-0.412-0.274-0.905-0.436-1.437-0.436c-1.432,0-2.593,1.161-2.593,2.594
					c0,1.432,1.161,2.593,2.593,2.593h15.831V16.43c1.213,0,2.196-0.983,2.196-2.197C22.311,13.02,21.327,12.036,20.114,12.036z"/>
				<path className="outline" d="M20.114,16.728H4.284c-1.568,0-2.843-1.275-2.843-2.843c0-1.568,1.275-2.844,2.843-2.844c0.433,0,0.856,0.098,1.242,0.287
					c0.353-1.823,1.931-3.156,3.815-3.156c1.1,0,2.125,0.458,2.865,1.27c0.787-1.348,2.199-2.169,3.771-2.169
					c2.418,0,4.387,1.968,4.387,4.387c0,0.049-0.004,0.098-0.008,0.146c1.256,0.136,2.204,1.173,2.204,2.427
					c0,1.266-0.965,2.309-2.196,2.435v0.013L20.114,16.728L20.114,16.728z M4.284,11.541c-1.292,0-2.343,1.051-2.343,2.344
					c0,1.291,1.051,2.343,2.343,2.343l15.831-0.048c1.072,0,1.946-0.873,1.946-1.947c0-1.073-0.874-1.947-1.946-1.947l-0.285,0.011
					l-0.002-0.279l0.018-0.147c0.009-0.069,0.02-0.139,0.02-0.211c0-2.143-1.744-3.887-3.887-3.887c-1.506,0-2.846,0.852-3.5,2.224
					l-0.177,0.373l-0.248-0.33C11.398,9.17,10.41,8.672,9.341,8.672c-1.752,0-3.202,1.324-3.372,3.079l-0.041,0.416l-0.347-0.231
					C5.195,11.677,4.746,11.541,4.284,11.541L4.284,11.541z"/>
			</g>
		);
	}
}

export default Cloud;